import ImportedProcedureLobbyView from 'ImportedProcedureLobby/views/ImportedProcedureLobbyView';

export default ImportedProcedureLobbyView;
